import React from 'react';
import clsx from 'clsx';

interface SectionProps {
  children: React.ReactNode;
  className?: string;
  id?: string;
  padding?: 'none' | 'sm' | 'md' | 'lg' | 'xl';
  background?: 'default' | 'alt' | 'gradient' | 'transparent';
}

const Section: React.FC<SectionProps> = ({
  children,
  className,
  id,
  padding = 'lg',
  background = 'transparent',
}) => {
  const paddingClasses = {
    none: '',
    sm: 'py-8 md:py-12',
    md: 'py-12 md:py-16',
    lg: 'py-16 md:py-24',
    xl: 'py-20 md:py-32',
  };

  const backgroundClasses = {
    default: 'bg-[var(--color-snow)]',
    alt: 'bg-[var(--color-swan)]',
    gradient: 'bg-gradient-to-b from-[var(--color-snow)] to-[var(--color-swan)]',
    transparent: '',
  };

  return (
    <section
      id={id}
      className={clsx(
        paddingClasses[padding],
        backgroundClasses[background],
        className
      )}
    >
      {children}
    </section>
  );
};

export default Section;